import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/apps/id/versions/page';

export const Route = createFileRoute('/_app/_chat/apps/$id/versions/')({
  component: Page,
});
